import { path } from "ramda";

export const organizationInfoSelector = path(["organizationInfo", "data"]);

export const loadingSelector = path(["organizationInfo", "isLoading"]);
export const loginSelector = path(["organizationInfo", "login"]);
export const loadingSelectorUpdate = path([
  "organizationInfo",
  "isLoadingUpdate",
]);

export const asyncJobsSelector = path(["getAsyncJobs", "data"]);

export const asyncJobsFileSelector = path(["getAsyncJobs", "file"]);

export const asyncJobsInfoSelector = path(["getAsyncJobs", "pageInfo"]);
export const asyncJobsFiltersSelector = path(["getAsyncJobs", "filters"]);

export const asyncJobsLoading = path(["getAsyncJobs", "isLoading"]);

export const asyncJobsNoEntriesMessageSelector = path([
  "getAsyncJobs",
  "noEntriesMessage",
]);

export const emailNotificationsSelector = path([
  "getEmailNotifications",
  "data",
]);

export const emailNotificationsLoadingSelector = path([
  "getEmailNotifications",
  "isLoading",
]);

export const updateFailedSelector = path(["getEmailNotifications", "failed"]);



// WEBPACK FOOTER //
// ./src/features/organization/selectors/index.js